import { defineStore } from "pinia";
import { ref } from "vue";

export const directionStore = defineStore("direction", {
    state: () => ({
        direction: ref("ltr"),
    }),
    getters: {
        getDirection() {
            return this.direction;
        },
    },
    actions: {
        setDirection(direction) {
            this.direction = direction;
            document.documentElement.setAttribute("dir", direction);
        },
    },
});
